module.exports = __webpack_public_path__ + "img/btn_menu_uncertified_c.fa57d2d8.png";